'use strict';

import {searchHelper} from '../../search_helper'

export default class quickFilters {
    constructor(options) {
        this.opt = options;
        this.filterWrapperSelector = 'form.filters-wrapper';
        this.bindHandlers();
    }

    setClearFiltersPath(path) {
        this.opt.clearFiltersPath = path;
    }

    bindHandlers() {
        let self = this;

        searchHelper.pushHistoryState(document.location);
        searchHelper.initAll();

        $(document).on('click', '.arrow-wrap', function () {
            $(this).find('img').toggleClass('active');
            $(this).parents('li').find('ul.second-level').toggleClass('active');
        });

        $('.search-form, form.filters-wrapper').submit(function (e) {
            e.preventDefault();

            let urlPath = self.opt.clearFiltersPath + '?' + $(this).serialize();
            let prettyUrl = searchHelper.getPrettyUrl(urlPath);
            if (!prettyUrl) {
                prettyUrl = urlPath;
            }

            window.open(prettyUrl, '_self');
        });

        $(document).on('click', '.filters-wrapper .filters li label span img', function () {
            $(this).closest('li').children('.second-level').toggleClass('active');
            $(this).toggleClass('active');
        });

        $(document).on('click', '.selected-filter:not(.range)', function () {
            let itemId = $(this).closest('div').attr('data-id');
            let itemType = $(this).closest('div').attr('data-filter-type');

            $('.filters.' + itemType).find('label.' + itemType + '_' + itemId).trigger('click');
            if ('min_price' === itemType) {
                $('#min_price').val(parseInt($(document).find('#min_price_hidden').val())).trigger('change');
            } else if ('max_price' === itemType) {
                $('#max_price').val(parseInt($(document).find('#max_price_hidden').val())).trigger('change');
            }

            if (window.screen.width <= 1023) {
                $('button.btn.apply-mobile').click();
            }
        });

        $(document).on('click', '.selected-filter.range', function () {
            let itemId = $(this).closest('div').attr('data-id');
            let itemType = $(this).closest('div').attr('data-filter-type');

            $('.filters.' + itemType).find('label.' + itemType + '_' + itemId).find('input').val('');
            let urlPath = self.opt.clearFiltersPath + '?' + $(self.filterWrapperSelector).serialize();
            let prettyUrl = searchHelper.getPrettyUrl(urlPath);
            if (!prettyUrl) {
                prettyUrl = urlPath;
            }

            searchHelper.getSearchAndFilterContent(prettyUrl);
        });

        $(document).on('click', '.clear-filter', function () {
            window.open(self.opt.clearFiltersPath, '_self');
        });

        $(document).on('change', self.filterWrapperSelector + ' input:not(.filter-search-row)', function () {
            let minPriceDefault = false;
            if ($('#min_price').val() === $(document).find('#min_price_hidden').val()) {
                minPriceDefault = true;
                $('#min_price').attr('disabled', true);
            }

            let maxPriceDefault = false;
            if ($('#max_price').val() === $(document).find('#max_price_hidden').val()) {
                maxPriceDefault = true;
                $('#max_price').attr('disabled', true);
            }

            if (false === $(this).prop('checked') && false === $(this).parents('ul').hasClass('second-level')) {
                $(this).parents('li').find('ul.second-level input:checked').click();
            }

            if (true === $(this).prop('checked') && $(this).parents('ul').hasClass('second-level')) {
                let industryCheckbox = $(this).parents('li.industry-filter-li').find('input').first();
                if (false === industryCheckbox.prop('checked')) {
                    industryCheckbox.click();
                }
            }

            let firstFilterInput = $('input[name=firstFilter]');
            let newFirstFilter = [];
            let checkedInputSelector = '.filters input[type=checkbox]:checked';

            if (typeof $(this).closest('label').attr('data-filter') !== typeof undefined) {
                newFirstFilter = $(this).closest('label').attr('data-filter');
            } else {
                newFirstFilter = $(this).closest('div.filters').attr('data-filter');
            }

            if (firstFilterInput.length === 0) {
                $(self.filterWrapperSelector).prepend('<input type="hidden" name="firstFilter" value="' + newFirstFilter + '">');
            } else {
                if ($(checkedInputSelector).length === 0) {
                    let cleanInputs = true;
                    let inputs = $('.filters.range input');
                    $.each(inputs, function (i, e) {
                        if ($(e).val() !== '') {
                            cleanInputs = false;
                            firstFilterInput.val($(e).closest('label').attr('data-filter'));
                            return false;
                        }
                    });
                    if (cleanInputs || (minPriceDefault && maxPriceDefault)) {
                        firstFilterInput.remove();
                    }
                } else {
                    let currentFirstFilter = firstFilterInput.val();
                    if ($('.filters.' + currentFirstFilter + ' input[type=checkbox]:checked').length === 0 && currentFirstFilter !== newFirstFilter) {
                        firstFilterInput.val(newFirstFilter);
                    } else if (currentFirstFilter === newFirstFilter) {
                        firstFilterInput.val($(checkedInputSelector).eq(0).closest('div.filters').attr('data-filter'));
                    }
                }
            }

            if (window.screen.width <= 1023) {
                return false; //prevent apply filter at mobile devices
            }

            let urlPath = self.opt.clearFiltersPath + '?' + $(self.filterWrapperSelector).serialize();
            let prettyUrl = searchHelper.getPrettyUrl(urlPath);
            if (!prettyUrl) {
                prettyUrl = urlPath;
            }

            searchHelper.getSearchAndFilterContent(prettyUrl);
        });

        window.onpopstate = function (e) {
            e.preventDefault();
            if (e.state) {
                $('#search-page-filter-and-content').html(e.state.html);
                document.title = e.state.pageTitle;
                searchHelper.initAll();
            }
        };
    }
}
